import { Box, Button, Flex } from '@chakra-ui/react'
import InputFloating from '../../../components/InputFloating'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'

export function Filtro({ getInfoSolicitacaoLayout }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const { register, handleSubmit } = useForm()

  async function handleGetInfoSolicitacaoLayout(data) {
    setSearchParams({
      numero_nota: data.numero_nota,
      layout_antigo: data.layout_antigo,
    })
  }

  return (
    <Box
      maxW={'100%'}
      w={'100%'}
      mx={'auto'}
      mt={'1rem'}
      textAlign="center"
      as="form"
      onSubmit={handleSubmit(handleGetInfoSolicitacaoLayout)}
    >
      <Flex
        maxW={'500px'}
        w={'100%'}
        mx={'auto'}
        mt={'1rem'}
        textAlign="center"
        position={'relative'}
        gap={2}
      >
        <InputFloating
          label="Número pedido"
          type="text"
          name="numero_nota"
          {...register('numero_nota')}
        />
        <InputFloating
          label="Layout finalizado"
          type="text"
          name="layout_antigo"
          {...register('layout_antigo')}
        />
        <Button
          type="submit"
          bgColor={'#378BBF'}
          color={'#fff'}
          size="md"
          width="150px"
          fontSize="sm"
          borderRadius="sm"
          _hover={{
            filter: 'brightness(0.8)',
          }}
        >
          Pesquisar
        </Button>
      </Flex>
    </Box>
  )
}
